<template>
  <!-- 카메라 신청 현황 -->
  <div>
    <v-card class="ma-4" id="head_height">
      <v-toolbar dense flat color="white">
        <v-toolbar-title class="font-weight-bold">
          <v-icon class="mr-2">mdi-view-list-outline</v-icon>카메라 신청 현황
        </v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-btn @click="Initialize();" icon small>
          <v-icon>
            refresh
          </v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider class="mr-4 ml-4"></v-divider>

      <v-card-text class="mt-2">
        <v-row>
          <v-col cols="12" sm="6" md="3" lg="12" class="d-flex">
            <div class="d-flex mb-n6">
              <IronDate ref="IronDateRef" v-model="sNowSelectDate" cLabel="신청기간" @update="onDateRangeChange" style="width:230px;" class="mr-4 hidden-md-and-down"/>
              <IronDate ref="IronDateRef" v-model="sRentNowSelectDate" cLabel="대여기간" @update="onRentDateRangeChange" style="width:230px;" class="mr-4 hidden-md-and-down"/>
              <v-select
                :items="zCameraState"
                v-model="cState"
                @change="GetCameraPerLog()"
                label="처리상태"
                class="mr-4 hidden-md-and-down"
                style="width:120px;"
                dense
                hide-details
              ></v-select>
              <v-text-field
                v-model="cNowSearchKeyWord"
                @keyup.enter="GetCameraPerLog()"
                @click:append="GetCameraPerLog()"
                append-icon="search"
                label="검색어"
                placeholder="이름 or 담당자"
                class="hidden-md-and-down"
                style="width:200px;"
                dense
                hide-details
                persistent-placeholder
              ></v-text-field>
            </div>
            <IronDate ref="IronDateRef" v-model="sNowSelectDate" cLabel="신청기간" @update="onDateRangeChange" style="width:100%" class="hidden-lg-and-up"/>
          </v-col>
          <v-col cols="12" sm="6" md="3" class="order-sm-2">
            <IronDate ref="IronDateRef" v-model="sRentNowSelectDate" cLabel="대여기간" @update="onRentDateRangeChange" style="width:100%" class="hidden-lg-and-up"/>
          </v-col>
          <v-col cols="12" sm="6" md="2" class="order-sm-1">
            <v-select
              :items="zCameraState"
              v-model="cState"
              @change="GetCameraPerLog()"
              label="처리상태"
              class="hidden-lg-and-up"
              hide-details
              dense
            ></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="3" class="order-sm-3">
            <v-text-field
              v-model="cNowSearchKeyWord"
              @keyup.enter="GetCameraPerLog()"
              @click:append="GetCameraPerLog()"
              append-icon="search"
              label="검색어"
              placeholder="이름 or 담당자"
              class="hidden-lg-and-up"
              dense
              hide-details
              persistent-placeholder
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>


    <!-- 하단의 결과 부분 -->
    <v-card class="ma-4" v-resize="onResize">
      <v-data-table
        :items="Records"
        :headers="headers"
        v-model="selected"
        :single-select="bSingleSelect"
        @click:row="handleClick"
        @dblclick:row="handleDoubleClick(selected[0])"
        :items-per-page="15"
        item-key="cCameraRentId"
        :height="ChangableHeight"
        fixed-header
      >
        <template v-slot:item.cCreateDateTime="{ item }">
          {{item.cCreateDateTime.substring(0,10)}}
        </template>
        <template v-slot:item.cZone="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <div
                style="max-width:220px;min-width:150px;"
                class="text-truncate"
                v-bind="attrs"
                v-on="on"
              >
                {{item.cZone}}
              </div>
            </template>
            <div style="max-width:300px !important;">{{item.cZone}}</div>
          </v-tooltip>
        </template>
        <template v-slot:item.cPurpose="{ item }">
          {{ getPurpose(item.cPurpose) }}
        </template>
        <template v-slot:item.cPeriod="{ item }">          
          {{item.cStartDate.substring(0,16) + " ~ " + item.cEndDate.substring(11,16)}}
        </template>
        <template v-slot:item.cState="{ item }">
          <v-chip label small :color="getStateColor(item.cState)" dark>{{ getState(item.cState) }}</v-chip>
        </template>
        <template v-slot:item.cComment="{ item }">
          <div class="d-flex center_all">
            <v-btn v-if="((item.cCustomId == CustomInfo.CustomId) || (item.cCustomId != CustomInfo.CustomId && CustomInfo.Manager != 'N')) && !(item.cState == 'R')" @click="ShowComment(item,item.cState)" icon><v-icon>mdi-account-details-outline</v-icon></v-btn>
            {{ item.cComment }}
          </div>
          <!-- <div v-if="item.cCustomId == CustomInfo.CustomId && (item.cState == 'A' || item.cState == 'J')">
            <v-btn @click="OpenDialog(item)" icon><v-icon>mdi-file-search-outline</v-icon></v-btn>
          </div> -->
        </template>
        <template v-slot:item.cEdit="{ item }">
          <div v-if="item.cCustomId == CustomInfo.CustomId && item.cState == 'R'" class="d-flex center_all" >
            <v-btn @click="OpenDialog(item)" icon><v-icon>mdi-pencil</v-icon></v-btn>
            <v-btn @click="ShowDelDialog(item)" icon><v-icon>delete</v-icon></v-btn>
          </div>
        </template>
        <template v-slot:no-data>
          <div class="black--text">{{cNoMsg}}</div>
        </template>
      </v-data-table>
    </v-card>


    <EditCameraDialog ref="EditCameraDialogRef" @ChangeCameraReq="ChangeCameraReq"/>
    <DelDialog ref="DelDialogRef" @DelCameraPerLog="onDelCameraRentData"/>
    <ResponseDialog ref="ResponseDialogRef"/>
  </div>
</template>

<script>
import BasicInfo from "@/BasicInfo.js";
import axios from "axios";
import EventBus from "@/eventBus.js";
import IronDate from '@/components/iron28Calendar/src/IronDate3.vue';
import Util from "../Util.js";
import { mapState } from "vuex";


import EditCameraDialog from "../components/EditCameraDialog.vue";
import DelDialog from "../components/DelDialog.vue";
import ResponseDialog from "../components/ResponseDialog.vue";

export default {
  components: {
    IronDate,
    EditCameraDialog,
    DelDialog,
    ResponseDialog,
  },
  data: () => ({
    bSingleSelect : false,
    bApplyDate : false,
    sStartDate : Util.sFormatDate(Util.sBefore1Moth()),
    sEndDate : Util.sFormatDate(Util.sAfter1Moth()),
    sNowSelectDate : Util.sFormatDate(Util.sBefore1Moth()) + " ~ " +  Util.sFormatDate(Util.sAfter1Moth()),
    sRendStartDate : Util.sFormatDate(Util.sBefore1Moth()),
    sRentEndDate : Util.sFormatDate(Util.sAfter1Moth()),
    sRentNowSelectDate : Util.sFormatDate(Util.sBefore1Moth()) + " ~ " +  Util.sFormatDate(Util.sAfter1Moth()),
    cNoMsg : "",
    cNowSearchKeyWord : "",
    ChangableHeight : "",
    cState : "ALL",
    selected : [],
    Records : [],
    headers : [
      { text: '신청번호', align: 'center', value: 'sNum', sortable : false, width : "10"},
      { text: '신청일', value: 'cCreateDateTime', width : "120"},
      { text: '대여기간', value: 'cPeriod', width : "200"},      
      { text: '촬영목적', value: 'cPurpose',width : "90",align : "center" },      
      { text: '촬영내용', value: 'cInfo', align : "center" },      
      { text: '모델', value: 'cCameraNm',width : "150"},      
      { text: '담당자', value: 'cChargeUserNm',width : "80"},      
      { text: '처리상태', value: 'cState',width : "80", align : "center" },
      { text: '의견', value: 'cComment',width:"80",align : "center"},
      { text: '작업', value: 'cEdit',width : "150", align : "center"},
    ],
  }),

  computed: {
    ...mapState(["CustomInfo","zPicPurpose","zCameraState"]),
  },

  created() {
  },
  mounted() {
    this.Initialize();
  },

  methods : {
    onResize(){
      let h1 = document.getElementById('footer_height').clientHeight
      let h2 = document.getElementById('head_height').clientHeight

      let iCalcHeight = window.innerHeight - h1 - h2 - 136

      if (iCalcHeight >= 300) {
        this.ChangableHeight = String(iCalcHeight) + "px"
      } else {
        this.ChangableHeight = "300px"
      }
    },
    // 삭제 확인 다이올로그 창 열기
    ShowDelDialog(item){
      this.$refs.DelDialogRef.ShowDialog("Camera",item,this.Records.indexOf(item));
    },

    // 확인 버튼 클릭 시 삭제 함수 실행하기
    onDelCameraRentData(index,item){
      this.DelCameraPerLog(index,item)
    },

    // 신청일자 바꾸기
    onDateRangeChange(daterange){
      this.sStartDate = Util.sFormatDate(daterange.startDate);
      this.sEndDate = Util.sFormatDate(daterange.endDate);
      this.sNowSelectDate = this.sStartDate + " ~ " +  this.sEndDate;
      this.GetCameraPerLog();
    },

    // 촬영일자 바꾸기
    onRentDateRangeChange(daterange){
      this.sRendStartDate = Util.sFormatDate(daterange.startDate);
      this.sRentEndDate = Util.sFormatDate(daterange.endDate);
      this.sRentNowSelectDate = this.sRendStartDate + " ~ " +  this.sRentEndDate;
      this.GetCameraPerLog();
    },

    // 수정이 완료되면 Recrod에서 해당 인덱스의 정보 업데이트
    ChangeCameraReq(item, index){      
      this.Records[index].cPurpose = item.cPurpose      
      this.Records[index].cInfo = item.cInfo
      this.Records[index].cStartDate = item.cStartDate
      this.Records[index].cEndDate = item.cEndDate
    },

    // 초기화 하기
    Initialize(){
      this.bApplyDate = true;
      this.DataInit();
      this.GetCameraPerLog();
    },

    // 데이터만 초기화 하기
    DataInit(){
      this.sStartDate = Util.sFormatDate(Util.sBefore1Moth());
      this.sEndDate = Util.sFormatDate(Util.sAfter1Moth());
      this.sNowSelectDate = Util.sFormatDate(Util.sBefore1Moth()) + " ~ " +  Util.sFormatDate(Util.sAfter1Moth());
      this.sRendStartDate = Util.sFormatDate(Util.sBefore1Moth());
      this.sRentEndDate = Util.sFormatDate(Util.sAfter1Moth());
      this.sRentNowSelectDate = Util.sFormatDate(Util.sBefore1Moth()) + " ~ " +  Util.sFormatDate(Util.sAfter1Moth());
      this.cState = "ALL";
      this.cNowSearchKeyWord = "";
    },

    //R:신청, G:승인권자 지정, A:승인, J:부결, I:반입, O:반출, T:종결
    getStateColor(cState){
      return this.zCameraState.find((e) => {return e.value == cState})?.color
    },

    // cState값에 맞게 한글 표기하기
    getState(cState){
      return this.zCameraState.find((e) => {return e.value == cState})?.text
    },

    // cPurpose 값에 맞게 한글 표기하기
    getPurpose(cPurpose){
      return this.zPicPurpose.find((e) => {return e.value == cPurpose})?.text
    },

    ShowNoResultMsg() {
      this.cNoMsg = ""

      setTimeout(() => {
        this.cNoMsg = "검색된 방문자가 없습니다."
      }, 300);
    },

    // 카메라 신청 현황 가져오기
    GetCameraPerLog() {
      this.Records = [];

      var posData = {
        Manager : this.CustomInfo.Manager,
        CorpId : this.CustomInfo.CorpId,
        SiteId : this.CustomInfo.SiteId,
        CustomId : this.CustomInfo.CustomId,
        StartDate : this.sStartDate,
        EndDate : this.sEndDate,
        RentStartDate : this.sRendStartDate,
        RentEndDate : this.sRentEndDate,
        State : this.cState,
        NowSearchKeyWord : this.cNowSearchKeyWord,
      };
      axios
        .post(process.env.VUE_APP_UIL_API + "GetCameraPerLog", posData, {
          headers: {
           "Authorization": this.CustomInfo.Token
          }
        })
        .then(res => {
          if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
          if (res.data.ResultCd === "00") {
            if (res.data.Result.length > 0) {
              for (let i =0; i < res.data.Result.length; i ++){
                res.data.Result[i].sNum = i + 1
              }
            } else {
              this.ShowNoResultMsg()
            }

            this.Records = res.data.Result
            this.bApplyDate = false
          } else if (res.data.ResultCd == BasicInfo.ERROR_CODE_CHECK_RIGHT_CUSTOM) {
            EventBus.$emit("onShowMsgBox", "정보 조회가 불가 합니다.","소속업체 또는 관리자 권한이 변경되었을 수 있습니다.\n새로고침 버튼을 눌러 주세요.");
            this.ShowNoResultMsg();
          } else {
            EventBus.$emit("onShowMsg",true,  "(" + res.data.ResultCd + ") " + res.data.Msg);
          }
        })
        .catch(err => {
          EventBus.$emit("onShowMsg",true, ""+err);        
        });
    },

    // 촬영 허가 신청 삭제하기
    DelCameraPerLog(index,item){
      var posData = {
        SiteId : this.CustomInfo.SiteId,
        CustomId : item.cCustomId,
        CorpId : this.CustomInfo.CorpId,
        CameraRentId : item.cCameraRentId,
      };

      console.log("posdata", posData)
      axios
        .post(process.env.VUE_APP_UIL_API + "DelCameraPerLog", posData, {
          headers: {
           "Authorization": this.CustomInfo.Token
          }
        })
        .then(res => {
          if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
          if (res.data.ResultCd == "66") { EventBus.$emit("onChangeCorpInfo"); return; }
          if (res.data.ResultCd == "55") { EventBus.$emit("onDelCustomInfo"); return; }
          if (res.data.ResultCd === "00") {
            this.Records.splice(index, 1);
            for (let i = 0; i < this.Records.length;i ++){
              this.Records[i].sNum = i+1
            }

            EventBus.$emit("onShowMsg",false,  "삭제가 완료되었습니다.");
          } else if (res.data.ResultCd === "04") {
            EventBus.$emit("onShowMsgBox","삭제되었거나 승인된 사항입니다.", "화면을 다시 접속 하여 확인하여 주세요.");
          } else {
            EventBus.$emit("onShowMsg",true,  "(" + res.data.ResultCd + ") " + res.data.Msg);
          }
        })
        .catch(err => {
          EventBus.$emit("onShowMsg",true, ""+err);        
        });
    },

    // 데이터 테이블 내부 데이터 클릭 시
    handleClick(value) {
      this.selected = [value];
    },

    // 데이터 테이블 목록 두 번 클릭 시 실행 함수
    handleDoubleClick(item){
      if (item.cState == "G") return
      if (item.cCustomId != this.CustomInfo.CustomId && this.CustomInfo.Manager == "N") return
      if (item.cCustomId != this.CustomInfo.CustomId && this.CustomInfo.Manager != "N" && item.cState == BasicInfo.REQ_TYPE_CARRY_STATE_REQ) return

      if (this.selected.length > 0 || item.iCameraPerId != undefined){
        this.OpenDialog(this.selected[0])
      }
    },

    async OpenDialog(item) {
      if (item.cState == "R") {    
        let EditIndex = this.Records.indexOf(item);    
        this.$refs.EditCameraDialogRef.ShowDialog(item,EditIndex)          
      } else {
        this.ShowComment(item,item.cState);
      }
    },

    ShowComment(oitem,StateNm) {
      this.$refs.ResponseDialogRef.ShowDialog(oitem,this.getState(StateNm),true)
    },
  }
}
</script>